export default {
	searchParams: {
		pgmId: null,
		jobGroupId: null,
		jobId: null,
		jobNm: null,
		fromDate: null,
		toDate: null,
		useYn: null
	},
	batchHistoryList: [],
	useYnList: [],	
	pagingInfo: {
		currentPage: 1,
		endPage: 1,
		pageUnit: 10,
		startPage: 1,
		totalSize: 1
	}
};
